import React, { useEffect } from 'react'

export const useKeyDownEvent = (onKeyDown: (event: KeyboardEvent) => void) => {
	useEffect(() => {
		window.addEventListener('keydown', onKeyDown)
		return () => window.removeEventListener('keydown', onKeyDown)
	})
}